import accounting from "accounting";

const formatter = new Intl.NumberFormat("en-NG", {
  style: "currency",
  currency: "NGN",
  minimumFractionDigits: 2,
});

export default formatter;

export const formatMoney = (amount, currency) => {
  // Check if there is a value passed. Convert value passed to number
  const amountIncoming = amount ? Number(amount) : 0;

  // Check the type of value passed. If type is "number", convert to two decimal places. Else, return 0.
  const amountToFormat =
    typeof amountIncoming === "number" ? amountIncoming : 0;

  // Check if currency is specified. If specified, use the specified currency. Else, use Naira
  return accounting.formatMoney(amountToFormat, {
    symbol: currency ? currency : " ",
    precision: 2, // Precision is same as toFixed(2)
  });
};
export const resolveDurationName = (period_type) => {
  if (period_type.toLowerCase() === "monthly") {
    return "months";
  } else if (period_type.toLowerCase() === "daily") {
    return "days";
  } else if (period_type.toLowerCase() === "yearly") {
    return "years";
  } else {
    return period_type;
  }
};
export const getMonthFromDays = (days) => {
  return Math.round(days / 30);
};
